import { ref, watch, computed } from '@vue/composition-api';
import axios from '@axios';
import useAuth from '@/auth/useAuth';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useDocumentList(isTemplate) {
  const refDocumentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'CreatedAt', label: i18nT(`Payment date`), sortable: true, thClass: "sk-header-content" },
    { key: 'Amount', label: i18nT(`Amount`), sortable: true },
    { key: 'PaymentType', label: i18nT(`Payment method`), sortable: true, thClass: 'pl-1 sk-header-content', tdClass: 'pl-1' },
    //{ key: 'Description', label: i18nT(`Description`), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'invoice_obj', label: i18nT(`Related Doc.`), sortable: true, thClass: 'pl-1 sk-header-content', tdClass: 'pl-1' },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ];
  const perPage = ref(10);
  const totalDocuments = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const invoiceType = ref({ value: -1, text: i18nT('All types') });
  const category = ref({ value: -1, text: i18nT('All types') });
  const currency = ref({ value: 0, text: i18nT('Any') });
  const paymentType = ref({ value: -1, text: i18nT('All types') });
  const documents = ref([]);
  const documentFilter = ref('');

  const dataMeta = computed(() => {
    const localItemsCount = refDocumentListTable.value
      ? refDocumentListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDocuments.value,
    };
  });

  const refetchData = () => {
    refDocumentListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      invoiceType,
      category,
      documentFilter,
      currency,
      paymentType,
      isSortDirDesc,
      sortBy,
    ],
    () => {
      refetchData();
    }
  );

  const fetchDocuments = (ctx, callback) => {
    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value,
    };

    if (isTemplate) {
      params.templates = 1;
    }

    if (currency.value.value != -1) {
      params['filters[currency]'] = currency.value.value;
    }
    if (category.value.value != -1) {
      params['filters[category]'] = category.value.value;
    }

    if (paymentType.value.value != -1) {
      params['filters[payment_type]'] = paymentType.value.value;
    }

    axios
      .get(`invoices/invoicePayments`, {
        params,
      })
      .then(({ data }) => {
        documents.value = data.data.invoice_payments;
        callback(data.data.invoice_payments);
        totalDocuments.value = data.data.pagination.records_count;
      });
  };

  return {
    fetchDocuments,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    invoiceType,
    category,
    currency,
    paymentType,
    documents,
    documentFilter,
    refetchData,
  };
}
